import { getFormattedFinance } from 'cng-common/helpers/numbers'
import { FINANCIAL_ROUNDING_CONFIG } from 'partner360/configs/financial/financialFormatting'
import { getAutoRounding } from 'partner360/helpers/getAutoRounding'

export const formatMoney = (value?: number | null, currency?: string | null) => {
  const normalized = Number(value) || 0
  const rounding = getAutoRounding(normalized)

  const { divisor, fractionDigits, suffix } = FINANCIAL_ROUNDING_CONFIG[rounding]

  return `${getFormattedFinance(normalized / divisor, {
    withCurrencySign: currency === 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}${suffix}`
}
